<template>
  <div class="active_table">
    <div class="toolbar">
      <div class="bg_tool">
        <div class="search">
          <i-input prefix="ios-search" placeholder="输入查询条件" v-model="search.name" style="width: auto" />
          <i-button type="default" style="margin-left: 1em;" @click="getData">搜索</i-button>
        </div>
        <div class="active">
          <i-button type="primary" @click="addData">添加</i-button>
          <i-button type="error" style="margin-left: 1em;">批量删除</i-button>
        </div>
      </div>
    </div>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align:right;margin-top: 1em" />
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
        <FormItem label="角色名" prop="name">
          <i-input v-model="formValidate.name" placeholder="输入角色名称"></i-input>
        </FormItem>
        <FormItem label="系统角色" prop="isSystem">
          <RadioGroup v-model="formValidate.isSystem">
            <Radio label="true">是</Radio>
            <Radio label="false">否</Radio>
          </RadioGroup>
        </FormItem>
        <!-- 权限选择 -->
        <FormItem v-for="(value, key, index) in enumMap.PowerList" :key="index" :label="key">
          <CheckboxGroup v-model="formValidate.permissionArray">
            <Checkbox v-for="item in value" :key="item.code" :label="item.code">{{ item.name }}</Checkbox>
          </CheckboxGroup>
        </FormItem>

        <FormItem label="描述" prop="description">
          <i-input v-model="formValidate.description" placeholder="输入相关描述"></i-input>
        </FormItem>
      </Form>

      <div slot="footer">
        <i-button type="primary" @click="activeData">{{ modal.title }}</i-button>
        <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>
    <!-- 提示对话框 -->
    <alert-p :modalAlert="alert.show" title="警告提醒" content="确定要删除吗？" @cansel="alert.show = false" @makeSure="delData"
      :modal_loading="alert.loading"></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.toolbar {
  width: 100%;
  padding: 3em 1em 1em 1em;
  height: 7.5em;

  .bg_tool {
    display: flex;
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 0.2em 1em;
    border: 1px solid #ccc;
    border-radius: 3.5px;
    justify-content: space-between;
    align-items: center;
  }
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
}
</style>

<script>
import { timeStamp } from "../../../util/common/date";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "角色名",
            key: "name",
            align: "center"
          },
          {
            title: "描述",
            key: "description",
            align: "center",
            render(h, params) {
              return h("span", {}, params.row.description || "暂无");
            }
          },
          {
            title: "是否启用",
            key: "isSystem",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h("i-switch", {
                  props: {
                    size: "large",
                    value: params.row.isSystem,
                    loading: this.table.isSystem_loading
                  },
                  scopedSlots: {
                    open: () => h("span", "禁用"),
                    close: () => h("span", "开启")
                  },
                  on: {
                    "on-change": value => {
                      // 是否启用切换
                      this.table.isSystem_loading = true; // 开启loading
                      this.$api.System.postRoleIsSystem(
                        {
                          content: { id: params.row.id, enabled: value }
                        },
                        ["uuids", "system"]
                      )
                        .then(res => {
                          if (res.code == 0) {
                            this.table.isSystem_loading = false;
                            this.$Message.success("切换成功");
                          } else {
                            this.table.isSystem_loading = false;
                            this.$Message.warning(res.message);
                          }
                        })
                        .catch(err => {
                          this.table.isSystem_loading = false;
                        });
                    }
                  }
                })
              ]);
            }
          },
          {
            title: "创建时间",
            key: "createDate",
            align: "center",
            render(h, params) {
              return h("span", {}, timeStamp(params.row.createDate));
            }
          },
          {
            title: "操作",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        //console.log(this.formValidate, params.row.permissionArray)
                        this.formValidate = {
                          name: params.row.name,
                          isSystem: params.row.isSystem + "",
                          permissionArray: params.row.permissionArray,
                          description: params.row.description,
                          id: params.row.id
                        };
                        // console.log(this.formValidate, params.row.permissionArray)
                        // this.formValidate.permissionArray = [];
                        //console.log(this.formValidate, params.row.permissionArray)
                        this.$api.System.getRolePower({ id: params.row.id }, [
                          "uuid",
                          "system"
                        ]).then(res => {
                          if (res.code == 0) {
                            this.formValidate.permissionArray =
                              res.data.rolePermissionMap;
                            this.modal.show = true;
                          }
                        });
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 10,

        total: 0,
        loading: true,
        isSystem_loading: false // 切换启用状态loading
      },
      // 查询
      search: {
        name: null
      },
      // 权限列表
      enumMap: {
        PowerList: [],
        PowerLoading: true
      },
      // 表单
      modal: {
        show: false,
        title: "添加"
      },
      // 表单数据
      formValidate: {
        name: "",
        isSystem: null,
        permissionArray: [],
        description: ""
      },
      // 验证
      ruleValidate: {
        name: [{ required: true, message: "不能为空", trigger: "blur" }],
        isSystem: [{ required: true, message: "不能为空", trigger: "change" }],
        description: [{ required: true, message: "不能为空", trigger: "blur" }]
      },
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      }
    };
  },
  created() {
    this.getData(); // 数据初始化
    this.getPower(); // 获取用户列表
  },
  methods: {
    addData() {
      // 打开表单添加
      this.modal.title = "添加";
      this.modal.show = true;
      this.formValidate = {
        name: "",
        isSystem: null,
        permissionArray: [],
        description: ""
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.System.getUserRoleEnum(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        [null, "system"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.System.postRoleDel({ content: { id: id } }, [
          "uuids",
          "system"
        ])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message ? res.message : "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    getPower() {
      // 获取权限列表
      this.enumMap.PowerLoading = true;
      this.$api.System.getPowerList(null, ["uuids", "system"]).then(res => {
        // console.log(res)
        if (res.code == 0) {
          // 请求成功
          this.enumMap.PowerList = res.data;
          this.enumMap.PowerLoading = false;
        } else {
          this.$Message.warning(res.message);
          this.enumMap.PowerLoading = false;
        }
      });
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let params = this.formValidate;
          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.System.postRoleAdd({ content: params }, [
              "uuids",
              "system"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else {
            this.$api.System.postRoleEdit({ content: params }, [
              "uuids",
              "system"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          }
        }
      });
    }
  }
};
</script>